import Products from 'merchandise-lib/constants/Product';
import VersionNumbers from '../../constants/VersionNumbers';
import { isProductVersion, isSalesServiceProOrEnt } from '../TypeGuards';
import { getProductInfoFromSkuId, getProductInfoFromSkuIdV2 } from './productUtils';
export const isCoreSeatSku = apiName => {
  const coreSeatApiNames = [Products.CORE_SEATS_INCLUDED_STARTER, Products.CORE_SEATS_STARTER, Products.CORE_SEATS_PROFESSIONAL, Products.CORE_SEATS_ENTERPRISE];
  return coreSeatApiNames.includes(apiName);
};

/**
 * Consider using isQuantifiableSalesOrServiceSeatSkuV2 instead, which uses growth-monetization-service-types.
 */
export const isQuantifiableSalesOrServiceSeatSku = (products, skuMap, skuId) => {
  const product = getProductInfoFromSkuId(products, skuId);
  const productVersion = skuMap[skuId];
  if (!product) {
    return false;
  }
  const isQuantifiable = productVersion.quantifiable;
  if (isSalesServiceProOrEnt(product.apiName) && isQuantifiable) {
    const apiName = product.apiName;
    return productVersion.versionNumber >= VersionNumbers[apiName].QUANTIFIABLE_SEAT;
  }
  return false;
};
export const isQuantifiableSalesOrServiceSeatSkuV2 = (products, skuMap, skuId) => {
  const product = getProductInfoFromSkuIdV2(products, skuId);
  const sku = skuMap[skuId];
  if (!product || !isProductVersion(sku)) {
    return false;
  }
  const isQuantifiable = sku.quantifiable;
  if (isSalesServiceProOrEnt(product.apiName) && isQuantifiable) {
    const apiName = product.apiName;
    return sku.versionNumber >= VersionNumbers[apiName].QUANTIFIABLE_SEAT;
  }
  return false;
};